





















import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {Helper} from 'simpli-web-sdk'

@Component
export default class RenderCargaDanfe extends Vue {
  @Prop({required: true}) danfe!: string

  copyToClipboard() {
    Helper.copyToClipboard(this.danfe)
    Helper.info('system.info.copiedToClipboard')
  }
}
